import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { BillingIntegrityVerdictEnum } from '../enums/billing-integrity-verdict.enum';

/**
 * Per-tenant billing integrity metrics row for GET billing/integrity.
 * Ratios and verdicts are computed in TS from raw SP counts.
 */
export class BillingIntegrityMetricDto {
  @TransformInt()
  tenantId!: number;

  @TransformInt()
  acceptedCount!: number;

  @TransformInt()
  orphanedAcceptanceCount!: number;

  orphanedAcceptanceRate!: number | null;

  orphanedAcceptanceVerdict!: BillingIntegrityVerdictEnum;

  @TransformInt()
  conversionPairCount!: number;

  @TransformInt()
  conversionBreachCount!: number;

  conversionDeltaRatio!: number | null;

  conversionDeltaVerdict!: BillingIntegrityVerdictEnum;

  @TransformInt()
  durationBreachCount!: number;

  conversionDurationDeltaRatio!: number | null;

  conversionDurationDeltaVerdict!: BillingIntegrityVerdictEnum;

  @TransformInt()
  settledFactCount!: number;

  @TransformInt()
  upsellBreachCount!: number;

  postCaptureUpsellRatio!: number | null;

  postCaptureUpsellVerdict!: BillingIntegrityVerdictEnum;

  shippedNetSum!: number;

  terminalNetSum!: number;

  @TransformInt()
  reversalCount!: number;

  reversalRate!: number | null;

  reversalVerdict!: BillingIntegrityVerdictEnum;

  @TransformInt()
  factCount!: number;

  lastSettledAt!: string | null;

  @TransformInt()
  correctedDocumentCount!: number;

  @TransformInt()
  maxRevision!: number;

  @TransformInt()
  declinedCount!: number;

  @TransformInt()
  declinedThenServedTier1Count!: number;

  @TransformInt()
  declinedThenServedTier2Count!: number;

  @TransformInt()
  declinedThenServedTier3Count!: number;

  declinedThenServedRate!: number | null;

  declinedThenServedVerdict!: BillingIntegrityVerdictEnum;

  identityCoverageRatio!: number | null;

  assetKeyCoverageRatio!: number | null;
}
